import { useContext, useEffect, useState } from "react";
import SwitchConfig from "../../generic/switch";
import TablePermissions from "../tablePermission";
import { api } from "../../../services/api";
import { Grid } from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";
import CardSys from "../../cardSys";
import { Box } from "@mui/system";
import SubTitlePages from "../../generic/subTitlePages";
import CloseButton from "../../generic/closeButton";
import { GlobalAlertContext } from "../../../contexts/GlobalAlertContext";
import ButtonSave from "../../buttonSave";
import CancelButton from "../../generic/cancelButton";

export default function Modules({ id, title, handleBack,updateTable }) {
  const [permiVisualizarSelected, setPermiVisualizarSelected] = useState([]);
  const [permiCriarSelected, setPermiCriarSelected] = useState([]);
  const [permiDeletarSelected, setPermiDeletarSelected] = useState([]);
  const [permiEditarSelected, setPermiEditarSelected] = useState([]);
  const [permiExportarSelected, setPermiExportarSelected] = useState([]);
  const [rows, setRows] = useState([]);

  const { user } = useContext(AuthContext);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);

  const permissionGroup = [];
  user?.permission?.map((el) => {
    if (el.name == "Grupos de permissão") {
      permissionGroup.push(...el.permission);
    }
  });

  useEffect(() => {
    getModulePermission();
  }, []);

  const saveGroupModules = async () => {
    const dashboard = [];
    const permissionUpdate = [];
    permiVisualizarSelected.map((e) => {
      if (!!e.checked) {
        permissionUpdate.push(e.id);
        if (!dashboard.includes(e.id)) dashboard.push(e.id);
      }
    });
    permiCriarSelected.map((e) => {
      if (!!e.checked) {
        permissionUpdate.push(e.id);
        if (!dashboard.includes(e.id)) dashboard.push(e.id);
      }
    });
    permiEditarSelected.map((e) => {
      if (!!e.checked) {
        permissionUpdate.push(e.id);
        if (!dashboard.includes(e.id)) dashboard.push(e.id);
      }
    });
    permiDeletarSelected.map((e) => {
      if (!!e.checked) {
        permissionUpdate.push(e.id);
        if (!dashboard.includes(e.id)) dashboard.push(e.id);
      }
    });
    permiExportarSelected.map((e) => {
      if (!!e.checked) {
        permissionUpdate.push(e.id);
        if (!dashboard.includes(e.id)) dashboard.push(e.id);
      }
    });

    const values = {
      name: title,
      permissions: permissionUpdate,
    };

    handleLoading(true);
    try {
      const { data } = await api({
        method: "put",
        url: `/group/${id}`,
        data: { ...values },
      });
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    updateTable()
  };

  /* Function to fetch the types of permissions */
  const getModulePermission = async () => {
    handleLoading(true);

    let data = []
    try{
      const { data:dados } = await api({
        method: "get",
        url: `/group/permissions/${id}`,
      });
      data = dados
      console.log(dados);
      
    } catch (err){
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);

    const dataTable = [];
    const permissionView = [];
    const permissionCreate = [];
    const permissionEdit = [];
    const permissionDelete = [];
    const permissionExport = [];
    data.map((e) => {
      e.permission.map((permi) => {
        if (permi.name == "Visualizar") {
            permissionView.push(permi);
        }
        if (permi.name == "Criar") {
            permissionCreate.push(permi);
        }
        if (permi.name == "Editar") {
            permissionEdit.push(permi);
        }
        if (permi.name == "Deletar") {
            permissionDelete.push(permi);
        }
        if (permi.name == "Exportar") {
            permissionExport.push(permi);
        }
      });
      dataTable.push({ id: e.id, modulos: e.name, permission: e.permission });
    });


    setPermiCriarSelected(permissionCreate);
    setPermiEditarSelected(permissionEdit);
    setPermiDeletarSelected(permissionDelete);
    setPermiExportarSelected(permissionExport);
    setPermiVisualizarSelected([...permissionView]);
    setRows(dataTable);
  };

  const columns = [
    {
      field: "modulos",
      headerName: "Modulos",
      width: "180",
    },
    {
      field: "Visualizar",
      headerName: "Visualizar",
      width: 128,
      editable: false,
      renderCell: (params) => {
        return (
          <SwitchConfig
            id={permiVisualizarSelected
              .find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Visualizar"
                  )?.id
              )
              ?.id.toString()}
            checked={
              !!permiVisualizarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Visualizar"
                  )?.id
              )?.checked
            }
            disabled={
              !params.row.permission.find(
                (element) => element.name == "Visualizar"
              )
            }
            onChange={({ currentTarget }) => {
              if (
                !!permiVisualizarSelected.find(
                  (e) =>
                    e.id ==
                    params.row.permission.find(
                      (element) => element.name == "Visualizar"
                    )?.id
                )?.checked
              ) {
                const list = params.row.permission.find(
                  (element) => element.name == "Visualizar"
                );
                if (!!list) {
                  list.checked = null;
                  const list2 = permiVisualizarSelected.filter(
                    (e, index) =>
                      e.id !=
                      params.row.permission.find(
                        (element) => element.name == "Visualizar"
                      )?.id
                  );
                  list2.push(list);
                  setPermiVisualizarSelected(list2);
                }
                const list3 = params.row.permission.find(
                  (element) => element.name == "Criar"
                );
                if (!!list3) {
                  list3.checked = null;
                  const list4 = permiCriarSelected.filter(
                    (e, index) =>
                      e.id !=
                      params.row.permission.find(
                        (element) => element.name == "Criar"
                      )?.id
                  );
                  list4.push(list);
                  setPermiCriarSelected(list4);
                }
                const list5 = params.row.permission.find(
                  (element) => element.name == "Editar"
                );
                if (!!list5) {
                  list5.checked = null;
                  const list6 = permiEditarSelected.filter(
                    (e, index) =>
                      e.id !=
                      params.row.permission.find(
                        (element) => element.name == "Editar"
                      )?.id
                  );
                  list6.push(list);
                  setPermiEditarSelected(list6);
                }
                const list7 = params.row.permission.find(
                  (element) => element.name == "Deletar"
                );
                if (!!list7) {
                  list7.checked = null;
                  const list8 = permiDeletarSelected.filter(
                    (e, index) =>
                      e.id !=
                      params.row.permission.find(
                        (element) => element.name == "Deletar"
                      )?.id
                  );
                  list8.push(list);
                  setPermiDeletarSelected(list8);
                }
                const list9 = params.row.permission.find(
                  (element) => element.name == "Exportar"
                );
                if (!!list9) {
                  list9.checked = null;
                  const list10 = permiExportarSelected.filter(
                    (e, index) =>
                      e.id !=
                      params.row.permission.find(
                        (element) => element.name == "Exportar"
                      )?.id
                  );
                  list10.push(list);
                  setPermiExportarSelected(list10);
                }
                return;
              }
              const list = params.row.permission.find(
                (element) => element.name == "Visualizar"
              );
              list.checked = params.row.permission.find(
                (element) => element.name == "Visualizar"
              ).id;
              const list2 = permiVisualizarSelected.filter(
                (e, index) =>
                  e.id !=
                  params.row.permission.find(
                    (element) => element.name == "Visualizar"
                  )?.id
              );
              list2.push(list);
              setPermiVisualizarSelected(list2);
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "Criar",
      headerName: "Criar",
      width: 128,
      editable: false,
      renderCell: (params) => {
        return (
          <SwitchConfig
            id={permiCriarSelected
              .find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Criar"
                  )?.id
              )
              ?.id.toString()}
            checked={
              !!permiCriarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Criar"
                  )?.id
              )?.checked
            }
            disabled={
              !params.row.permission.find(
                (element) => element.name == "Criar"
              ) ||
              !!!permiVisualizarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Visualizar"
                  )?.id
              )?.checked
            }
            onChange={({ currentTarget }) => {
              if (
                !!permiCriarSelected.find(
                  (e) =>
                    e.id ==
                    params.row.permission.find(
                      (element) => element.name == "Criar"
                    )?.id
                )?.checked
              ) {
                const list = params.row.permission.find(
                  (element) => element.name == "Criar"
                );
                list.checked = null;
                const list2 = permiCriarSelected.filter(
                  (e, index) =>
                    e.id !=
                    params.row.permission.find(
                      (element) => element.name == "Criar"
                    )?.id
                );
                list2.push(list);
                setPermiCriarSelected(list2);
                return;
              }
              const list = params.row.permission.find(
                (element) => element.name == "Criar"
              );
              list.checked = params.row.permission.find(
                (element) => element.name == "Criar"
              ).id;
              const list2 = permiCriarSelected.filter(
                (e, index) =>
                  e.id !=
                  params.row.permission.find(
                    (element) => element.name == "Criar"
                  )?.id
              );
              list2.push(list);
              setPermiCriarSelected(list2);
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "Editar",
      headerName: "Editar",
      width: 128,
      editable: false,
      renderCell: (params) => {
        return (
          <SwitchConfig
            id={permiEditarSelected
              .find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Editar"
                  )?.id
              )
              ?.id.toString()}
            checked={
              !!permiEditarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Editar"
                  )?.id
              )?.checked
            }
            disabled={
              !params.row.permission.find(
                (element) => element.name == "Editar"
              ) ||
              !!!permiVisualizarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Visualizar"
                  )?.id
              )?.checked
            }
            onChange={({ currentTarget }) => {
              if (
                !!permiEditarSelected.find(
                  (e) =>
                    e.id ==
                    params.row.permission.find(
                      (element) => element.name == "Editar"
                    )?.id
                )?.checked
              ) {
                const list = params.row.permission.find(
                  (element) => element.name == "Editar"
                );
                list.checked = null;
                const list2 = permiEditarSelected.filter(
                  (e, index) =>
                    e.id !=
                    params.row.permission.find(
                      (element) => element.name == "Editar"
                    )?.id
                );
                list2.push(list);
                setPermiEditarSelected(list2);
                const list3 = params.row.permission.find(
                  (element) => element.name == "Deletar"
                );
                if (!!list3) {
                  list3.checked = null;
                  const list4 = permiDeletarSelected.filter(
                    (e, index) =>
                      e.id !=
                      params.row.permission.find(
                        (element) => element.name == "Deletar"
                      )?.id
                  );
                  list4.push(list);
                  setPermiDeletarSelected(list4);
                }
                return;
              }
              const list = params.row.permission.find(
                (element) => element.name == "Editar"
              );
              list.checked = params.row.permission.find(
                (element) => element.name == "Editar"
              ).id;
              const list2 = permiEditarSelected.filter(
                (e, index) =>
                  e.id !=
                  params.row.permission.find(
                    (element) => element.name == "Editar"
                  )?.id
              );
              list2.push(list);
              setPermiEditarSelected(list2);
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "Deletar",
      headerName: "Deletar",
      width: 128,
      editable: false,
      renderCell: (params) => {
        return (
          <SwitchConfig
            id={permiDeletarSelected
              .find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Deletar"
                  )?.id
              )
              ?.id.toString()}
            checked={
              !!permiDeletarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Deletar"
                  )?.id
              )?.checked
            }
            disabled={
              !params.row.permission.find(
                (element) => element.name == "Deletar"
              ) ||
              !!!permiVisualizarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Visualizar"
                  )?.id
              )?.checked ||
              !!!permiEditarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Editar"
                  )?.id
              )?.checked
            }
            onChange={({ currentTarget }) => {
              if (
                !!permiDeletarSelected.find(
                  (e) =>
                    e.id ==
                    params.row.permission.find(
                      (element) => element.name == "Deletar"
                    )?.id
                )?.checked
              ) {
                const list = params.row.permission.find(
                  (element) => element.name == "Deletar"
                );
                list.checked = null;
                const list2 = permiDeletarSelected.filter(
                  (e, index) =>
                    e.id !=
                    params.row.permission.find(
                      (element) => element.name == "Deletar"
                    )?.id
                );
                list2.push(list);
                setPermiDeletarSelected(list2);
                return;
              }
              const list = params.row.permission.find(
                (element) => element.name == "Deletar"
              );
              list.checked = params.row.permission.find(
                (element) => element.name == "Deletar"
              ).id;
              const list2 = permiDeletarSelected.filter(
                (e, index) =>
                  e.id !=
                  params.row.permission.find(
                    (element) => element.name == "Deletar"
                  )?.id
              );
              list2.push(list);
              setPermiDeletarSelected(list2);
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "Exportar",
      headerName: "Exportar",
      width: 128,
      editable: false,
      renderCell: (params) => {
        return (
          <SwitchConfig
            id={permiExportarSelected
              .find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Exportar"
                  )?.id
              )
              ?.id.toString()}
            checked={
              !!permiExportarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Exportar"
                  )?.id
              )?.checked
            }
            disabled={
              !params.row.permission.find(
                (element) => element.name == "Exportar"
              ) ||
              !!!permiVisualizarSelected.find(
                (e) =>
                  e.id ==
                  params.row.permission.find(
                    (element) => element.name == "Visualizar"
                  )?.id
              )?.checked
            }
            onChange={({ currentTarget }) => {
              if (
                !!permiExportarSelected.find(
                  (e) =>
                    e.id ==
                    params.row.permission.find(
                      (element) => element.name == "Exportar"
                    )?.id
                )?.checked
              ) {
                const list = params.row.permission.find(
                  (element) => element.name == "Exportar"
                );
                list.checked = null;
                const list2 = permiExportarSelected.filter(
                  (e, index) =>
                    e.id !=
                    params.row.permission.find(
                      (element) => element.name == "Exportar"
                    )?.id
                );
                list2.push(list);
                setPermiExportarSelected(list2);
                return;
              }
              const list = params.row.permission.find(
                (element) => element.name == "Exportar"
              );
              list.checked = params.row.permission.find(
                (element) => element.name == "Exportar"
              ).id;
              const list2 = permiExportarSelected.filter(
                (e, index) =>
                  e.id !=
                  params.row.permission.find(
                    (element) => element.name == "Exportar"
                  )?.id
              );
              list2.push(list);
              setPermiExportarSelected(list2);
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
  ];

  return (
    <>
      <CardSys>
        <Grid container>
          <Grid
            item
            sx={{ display: "flex" }}
            justifyContent="space-between"
            alignItems="center"
            xs={12}
          >
            <SubTitlePages sx={{ display: "flex" }}>
              <SubTitlePages sx={{ fontWeight: "bold", marginRight: "4px" }}>
                Editar - Perfil de acesso -{" "}
              </SubTitlePages>{" "}
              {title}
            </SubTitlePages>
            <Box>
              <CancelButton
                onClick={() => {getModulePermission(); handleBack()}}
              >
                Cancelar
              </CancelButton>
              {!!permissionGroup.find((el) => el.name == "Editar") ? (
                <ButtonSave
                  onClick={saveGroupModules}
                >
                  Salvar
                </ButtonSave>
              ) : null}
            </Box>
            <CloseButton onClick={handleBack}></CloseButton>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "16px" }}>
            <TablePermissions rows={rows} columns={columns}></TablePermissions>
          </Grid>
        </Grid>
      </CardSys>
    </>
  );
}
